import {apiCall} from '../actions/api'
import {setNotification} from 'state/actions'

const LOADED = 'app/categories/LOADED'

export default (state = {_gen: 0}, action = {}) => {
	switch (action.type) {
		case LOADED: {
			const {categories} = action
			categories._gen = state._gen + 1
			return categories
		}
		default:
			return state
	}
}

export const getCategories = () => (dispatch) =>
	dispatch(apiCall("/api/getCategories"))
	.then(response => dispatch({type: LOADED, categories: response}))
	.catch(() => dispatch(setNotification('Categories could not be fetched.', 'error'))) // eslint-disable-line no-alert



// WEBPACK FOOTER //
// ./state/ducks/categories.js